import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),

      clearUser: () => {
        set({ user: null });
        useStore.persist.clearStorage();
      },

      slot: null,
      setSlot: (slot) => set({ slot }),

      notifyCount: 0,
      setNotifyCount: (count) => set({ notifyCount: count }),

      holiday: { reason: "", is_holiday: false },
      setHoliday: (key, val) =>
        set((prev) => ({ holiday: { ...prev.holiday, [key]: val } })),

      assigned: null,
      setAssigned: (assigned) => set({ assigned }),

      messages: { list: [], unread: 0, onChat: false },
      setMessages: (key, val) =>
        set((prev) => ({
          messages: {
            ...prev.messages,
            [key]:
              key === "list"
                ? Array.from(
                    new Map(
                      [...prev.messages?.[key]?.values(), ...val].map(
                        (item) => [item?.id, item],
                      ),
                    ).values(),
                  )
                : val,
          },
        })),
      clearMessages: () =>
        set({
          messages: { list: [], unread: 0, onChat: false },
        }),
    }),
    { name: "user-storage" },
  ),
);

export default useStore;
